import React, { Component } from 'react';
import {
  saveLayout,
  toggleLogoutPopup,
  REDUCER_NAME as SIDEBAR_REDUCER_NAME,
} from '../../sidebar/reducer';
import { connect } from 'react-redux';

class Logout extends Component {
  handleLogout = e => {
    e.preventDefault();
    const { toggleLogoutPopup, saveLayout, isShowPopupLogout } = this.props;
    if (!isShowPopupLogout) {
      saveLayout();
    }
    toggleLogoutPopup();
  };

  render() {
    return (
      <div className="logout-link ml-6">
        <a href="#" onClick={this.handleLogout}>
          <span className="bg-bor-sp">
            <i className="icon-log-out" />
          </span>
        </a>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isShowPopupLogout: state[SIDEBAR_REDUCER_NAME].userInfo.isShowPopupLogout,
});

const mapDispatchToProps = {
  toggleLogoutPopup,
  saveLayout,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Logout);
